"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const TextButton_1 = __importDefault(require("./TextButton"));
const FormButton_1 = __importDefault(require("./FormButton"));
const DefaultButton_1 = __importDefault(require("./DefaultButton"));
const Button = props => {
  const {
    variant = 'primary',
    size = 'md',
    isClicked,
    ...rest
  } = props;
  if (variant === 'text') {
    return (0, jsx_runtime_1.jsx)(TextButton_1.default, {
      ...rest,
      size: size
    });
  }
  if (variant === 'form') {
    return (0, jsx_runtime_1.jsx)(FormButton_1.default, {
      ...rest,
      isClicked: isClicked
    });
  }
  return (0, jsx_runtime_1.jsx)(DefaultButton_1.default, {
    ...rest,
    variant: variant,
    size: size
  });
};
exports.default = Button;